import React from 'react';
import MainHeader from './Header';
import DemoBanner from '../components/DemoBanner';
import DevBanner, { DEV_BANNER_HEIGHT } from '../components/DevBanner';

const MainLayout = ({ children, isHeaderFooter }) => {
  return (
    <main
      id="MainLayout"
      className={isHeaderFooter ? 'is-admin Layouts' : 'Layouts'}
      style={DEV_BANNER_HEIGHT ? { paddingTop: DEV_BANNER_HEIGHT } : undefined}
    >
      <DevBanner />
      <DemoBanner />
      {isHeaderFooter ? <MainHeader /> : null}
      {children}
    </main>
  );
};

export default MainLayout;
